import { useEffect, useState } from "react";

interface GestureLegendProps {
  isVisible: boolean;
  onDismiss: () => void;
  forceShow?: boolean;
}

const STORAGE_KEY = "gesture-onboarding-seen";

const gestureMappings = [
  { gesture: "Thumb Up", action: "Play" },
  { gesture: "Fist", action: "Pause" },
  { gesture: "Victory", action: "Toggle Instructions" },
  { gesture: "Hold Palm", action: "Show/Hide Controls" },
  { gesture: "Swipe Left", action: "Previous" },
  { gesture: "Swipe Right", action: "Next" },
];

export function GestureLegend({ isVisible, onDismiss, forceShow }: GestureLegendProps) {
  const [dismissed, setDismissed] = useState(() => {
    return localStorage.getItem(STORAGE_KEY) === "true";
  });

  const shouldShow = isVisible && (!dismissed || forceShow);

  function handleDismiss() {
    localStorage.setItem(STORAGE_KEY, "true");
    setDismissed(true);
    onDismiss();
  }

  useEffect(() => {
    if (!shouldShow) return;
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        handleDismiss();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [shouldShow]);

  if (!shouldShow) return null;

  return (
    <div
      data-testid="gesture-legend"
      className="rounded-lg bg-background/95 p-4 shadow-lg backdrop-blur"
    >
      <h3 className="mb-3 text-sm font-semibold text-foreground">
        Gesture Controls
      </h3>
      <ul className="flex flex-col gap-2">
        {gestureMappings.map((m) => (
          <li
            key={m.gesture}
            data-testid="gesture-legend-item"
            className="flex items-center justify-between text-sm text-muted-foreground"
          >
            <span className="font-medium text-foreground">{m.gesture}</span>
            <span>{m.action}</span>
          </li>
        ))}
      </ul>
      <button
        onClick={handleDismiss}
        className="mt-3 w-full rounded-md bg-primary px-3 py-1.5 text-xs font-medium text-primary-foreground"
        aria-label="Got it"
      >
        Got it
      </button>
    </div>
  );
}
